

import React, { useEffect, useState } from "react";
import Header from '../component/Header'
import Banner from './Banner'
import Footer from './Footer'
import About from './About'
import Colleges from './Colleges'
import Stream from './Stearm'
import Whyus from './Whyus'
import AutoPopup from '../component/AutoPopup';
import { Grid, Fab, useScrollTrigger } from '@mui/material';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import Fade from '@mui/material/Fade';
import PropTypes from 'prop-types';

function ScrollTop(props) {
  const { children, window } = props;

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');
    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <Fade in={trigger}>
      <div
        onClick={handleClick}
        role="presentation"
        style={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1000 // Ensure it stays on top
        }}
      >
        {children}
      </div>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

const Home = (props) => {
  const [isAutoPopupOpen, setIsAutoPopupOpen] = useState(false);

  const handleOpenAutoPopup = () => {
    const formSubmitted = sessionStorage.getItem("isFormSubmitted");
    if (!formSubmitted) {
      setIsAutoPopupOpen(true);
    }
  };
  const handleCloseAutoPopup = () => {
    setIsAutoPopupOpen(false);
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      handleOpenAutoPopup();
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <Grid sx={{ overflowX: 'hidden', }}>
      <div id="back-to-top-anchor" />
      <Header />
      <Banner />
      <About />
      <Colleges />
      <Whyus />
      <Stream />
      <ScrollTop {...props}>
        <Fab size='small' aria-label='scroll back to top' sx={{ backgroundColor: 'white' }} >
          <ArrowCircleUpIcon sx={{ fontSize: '50px', color: '#31331a' }} />
        </Fab>
      </ScrollTop>
      <AutoPopup
        isOpen={isAutoPopupOpen}
        onClose={handleCloseAutoPopup}
        leadFlag="Organic"
      />
      <Footer />
    </Grid>
  );
};

export default Home;

